<template>
  <div class="mt-8 flex h-[2.87325em] w-full justify-end space-x-8 sm:w-auto">
    <TaskSkipButton v-if="correct == null" @skip="$emit('skip', $event)" />

    <transition
      name="fade"
      mode="out-in"
      class="relative"
      enter-active-class="transition-all duration-300 ease-in"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-all duration-100 ease-out"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <button
        :disabled="correct != null"
        type="submit"
        class="absolute justify-center w-full btn-primary sm:mt-0 sm:ml-3 sm:w-auto"
        v-if="correct == null"
        key="submitButton"
        :class="{ 'text-sm': cta.includes('please wait') }"
      >
        {{ cta }}
      </button>

      <button
        disabled
        class="absolute inline-flex items-center justify-end w-full px-4 py-2 text-lg font-medium bg-transparent border border-transparent cursor-default pointer sm:mt-0 sm:ml-3 sm:w-auto"
        v-else-if="correct != null"
      >
        <div class="flex items-center" :class="correct ? 'border-green-500 text-green-500' : 'border-red-500 text-red-500'" v-show="correct">
          <CheckCircleIcon class="w-6 h-6" aria-hidden="true" />
          <span class="ml-2" v-text="type == 'textLong' ? 'Saved' : 'Correct'"></span>
        </div>
        <div class="flex items-center" :class="correct ? 'border-green-500 text-green-500' : 'border-red-500 text-red-500'" v-show="!correct">
          <XCircleIcon class="w-6 h-6" aria-hidden="true" />
          <span class="ml-2">Incorrect</span>
        </div>
      </button>
    </transition>
  </div>
</template>
<script>
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/outline";
import TaskSkipButton from "./TaskSkipButton";
export default {
  components: {
    CheckCircleIcon,
    XCircleIcon,
    TaskSkipButton,
  },
  props: {
    cta: String,
    correct: null,
    type: String,
  },
};
</script>
